module.exports = "<template>\n    <div class=\"colorbox\" css.bind=\"'background-color: ' + value + ';'\"></div>\n</template>\n";